'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = exports.breakpointCodes = undefined;

var _maxSafeInteger = require('babel-runtime/core-js/number/max-safe-integer');

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpointCodes = exports.breakpointCodes = {
    EXTRA_NARROW: 'xn',
    NARROW: 'n',
    MEDIUM: 'm',
    WIDE: 'w',
    EXTRA_WIDE: 'xw'
};

var config = exports.config = [{
    code: breakpointCodes.EXTRA_NARROW,
    name: 'extra narrow',
    min: 0,
    max: 479,
    media: '(max-width: 479px)'
}, {
    code: breakpointCodes.NARROW,
    name: 'narrow',
    min: 480,
    max: 719,
    media: '(min-width: 480px) and (max-width: 719px)'
}, {
    code: breakpointCodes.MEDIUM,
    name: 'medium',
    min: 720,
    max: 989,
    media: '(min-width: 720px) and (max-width: 989px)'
}, {
    code: breakpointCodes.WIDE,
    name: 'wide',
    min: 990,
    max: 1277,
    media: '(min-width: 990px) and (max-width: 1277px)'
}, {
    code: breakpointCodes.EXTRA_WIDE,
    name: 'extra wide',
    min: 1278,
    max: _maxSafeInteger2.default || Number.MAX_VALUE,
    media: '(min-width: 1278px)'
}];


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/config.js
// module id = 693
// module chunks = 1